import React, { ChangeEvent, Component } from "react";
import "./CaptureSignatureModal.scss";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import IShipment_GroupUI from "../../../models/IShipment_GroupUI";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import OwButton from "../OwButton/OwButton";
import OwCheckbox from "../OwCheckbox/OwCheckbox";
import OwInputWrapper from "../OwInputWrapper/OwInputWrapper";
import OwLabel from "../OwLabel/OwLabel";
import OwTitle from "../OwTitle/OwTitle";
import SignatureCanvas from "react-signature-canvas";
import { Socket } from "socket.io-client";

type Props = {
    closeModalFn: () => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    shipmentGroup: IShipment_GroupUI;
    captureSignatureFn: (shipmentGroupGuid: string, vendorGuid: string, name: string, mark_picked_up: boolean, jpgUrl: any) => void;
};

type State = {
    name: string;
    mark_picked_up: boolean;
};

class CaptureSignatureModal extends Component<Props, State> {
    sigCanvas: SignatureCanvas | null = null;

    constructor(props: any) {
        super(props);

        this.state = {
            name: "",
            mark_picked_up: true,
        };
    }

    componentDidMount(): void {
        if (this.sigCanvas) {
            // this.sigCanvas
        }
    }

    componentWillUnmount(): void {}

    closeModal = () => {
        this.props.closeModalFn();
    };

    saveSignature = () => {
        const shipmentGroupGuid = this.props.shipmentGroup.guid;
        const vendorGuid = this.props.shipmentGroup.Vendor!.guid;

        const jpgObj = this.sigCanvas!.toDataURL("image/jpeg")!;

        this.props.captureSignatureFn(shipmentGroupGuid, vendorGuid, this.state.name, this.state.mark_picked_up, jpgObj);
    };

    clearSignature = () => {
        this.setState(
            {
                name: "",
            },
            () => {
                if (this.sigCanvas) {
                    this.sigCanvas.clear();
                }
            }
        );
    };

    handleChange = (e: ChangeEvent<any>) => {
        let value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        if (name === "name") {
            const nameValueArr = `${value}`.split(" ");
            const processedNameValueArr: string[] = [];

            const re = /(\b[a-z](?!\s))/g;

            for (let i = 0; i < nameValueArr.length; ++i) {
                const nameValue = nameValueArr[i];

                const replacedNameValue = nameValue.replace(re, (x) => {
                    return x.toUpperCase();
                });

                processedNameValueArr.push(replacedNameValue);
            }

            value = processedNameValueArr.join(" ");
        }

        const state: any = {
            [name]: value,
        };

        this.setState(state);
    };

    render() {
        return (
            <div className={"CaptureSignatureModal p-2"}>
                <div className={"w-100"}>
                    <div className={"d-flex justify-content-between"}>
                        <OwTitle leftIconName={"fad fa-pen-fancy"} title={"capture_signature"} tag={"h3"} />
                        <div>
                            <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={this.closeModal} />
                        </div>
                    </div>
                </div>

                <div>
                    <SignatureCanvas
                        ref={(ref) => {
                            this.sigCanvas = ref;
                        }}
                        backgroundColor={"white"}
                        penColor="black"
                        canvasProps={{ width: 500, height: 200, className: "sigCanvas" }}
                    />
                </div>

                <div className={"p-relative"}>
                    <OwLabel title={"type_name_to_capture"} />
                    <OwInputWrapper name={"name"} fn={this.handleChange} value={this.state.name} />
                    <div className={"signatureRow"}>
                        <div className={"xStart"}>X</div>
                        <div className={"name"}>{this.state.name}</div>
                    </div>
                </div>

                <div className={"mb-4"}>
                    <OwCheckbox
                        name={"mark_picked_up"}
                        label={this.props.shipmentGroup.is_local_pickup ? "mark_picked_up" : "mark_delivered"}
                        fn={this.handleChange}
                        truthyVal={true}
                        falsyVal={false}
                        checked={this.state.mark_picked_up}
                        disabled={true}
                    />
                </div>

                <div>
                    <OwButton title={"save"} fn={this.saveSignature} />
                    <OwButton title={"clear"} fn={this.clearSignature} className={"ms-2 btn-danger"} />
                </div>
            </div>
        );
    }
}

export default CaptureSignatureModal;
